import type { SelectionGeometry } from "src/js/stores/map/store";
import { geoJsonPolyToGoogleBounds } from "src/js/util/map_util";
import {
  EXPLORER_WIDTH_DESKTOP_PX,
  LOCATION_SEARCH_HEIGHT_MOBILE_PX,
  NAVBAR_HEIGHT_MOBILE_PX,
  WORKBENCH_HEIGHT_MOBILE_PC,
  WORKBENCH_WIDTH_DESKTOP_PX,
} from "react-migration/constants";
import { isMobile } from "../theme/hooks/useIsMobile";

type NavigateToGeometryProps = {
  geometry?: SelectionGeometry | null;
  googleMap?: google.maps.Map | null;
  showLHP?: boolean;
  showRHP?: boolean;
  leftOffset?: number;
  rightOffset?: number;
  bottomOffset?: number;
  topOffset?: number;
};

export const navigateToGeometry = ({
  geometry,
  googleMap,
  leftOffset,
  rightOffset,
  topOffset,
  bottomOffset,
  showLHP,
  showRHP,
}: NavigateToGeometryProps) => {
  if (!googleMap || !geometry) return;

  const isOnMobile = isMobile();
  const { top, bottom } = getMobilePanels({ topOffset, bottomOffset });
  const { left, right } = getDesktopPanels({ leftOffset, rightOffset, showLHP, showRHP });

  if (geometry.type === "Polygon" || geometry.type === "MultiPolygon") {
    const bounds = geoJsonPolyToGoogleBounds(geometry);
    if (isOnMobile) {
      googleMap.fitBounds(bounds, { top, bottom });
    } else {
      googleMap.fitBounds(bounds, { left, right });
    }
  } else if (geometry.type === "Point") {
    const [lng, lat] = geometry.coordinates;
    if (typeof lng !== "number" || typeof lat !== "number") return;
    googleMap.setCenter({ lng, lat });
    if (isOnMobile) {
      googleMap.panBy(0, bottom / 2 - top / 2);
    }
  }
};

type GetPanels = {
  showLHP?: boolean;
  showRHP?: boolean;
  leftOffset?: number;
  rightOffset?: number;
  topOffset?: number;
  bottomOffset?: number;
};
const getDesktopPanels = ({ showLHP, showRHP, leftOffset, rightOffset }: GetPanels) => ({
  left: showLHP ? leftOffset ?? EXPLORER_WIDTH_DESKTOP_PX : 0,
  right: showRHP ? rightOffset ?? WORKBENCH_WIDTH_DESKTOP_PX : 0,
});

const getMobilePanels = ({ topOffset, bottomOffset }: GetPanels) => ({
  top: topOffset ?? LOCATION_SEARCH_HEIGHT_MOBILE_PX,
  bottom:
    ((window.innerHeight - NAVBAR_HEIGHT_MOBILE_PX) / 100) * (bottomOffset ?? WORKBENCH_HEIGHT_MOBILE_PC) +
    NAVBAR_HEIGHT_MOBILE_PX,
});
